<!-- 选择采购单号 -->
<template>
<span>
    <el-dialog
        :title="msg('选择采购单号')"
        :visible.sync="visible"
        :close-on-click-modal="false"
        size="mini"
        width="50%"
    >
        <el-button-group style="margin-bottom: 20px;">
            <el-button type="primary" size="small" @click="openPddLogin()">拼多多</el-button>
            <el-button disabled :type="activePlatform === 'taobao' ? 'primary' : ''" size="small">淘宝</el-button>
            <el-button disabled :type="activePlatform === '1688' ? 'primary' : ''" size="small">1688</el-button>
        </el-button-group>
        <el-table :data="tableData" border style="width: 100%" max-height="600">
            <el-table-column prop="created" label="日期" min-width="130"></el-table-column>
            <el-table-column prop="orderCode" label="单号" min-width="120"> </el-table-column>
            <el-table-column prop="spec" label="商品名称" min-width="120"> </el-table-column>
            <el-table-column prop="qty" label="数量" min-width="60"> </el-table-column>
            <el-table-column prop="price" label="单价" min-width="80"> </el-table-column>
            <el-table-column prop="status" label="状态" min-width="120"> </el-table-column>
            <el-table-column fixed="right" label="操作" min-width="80">
                <template slot-scope="scope">
                    <el-button @click="submitCode(scope.row)" type="primary" size="mini">
                        选择
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</span>    
</template>

<script>
export default {
    name: "SearchPurchaseCodeDialog",
    mounted(){
    },
    data(){
        return {
            visible: false,
            activePlatform: '',
            tableData: [],
            rowIndex: null,
        } 
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        }
    },
    methods: {
        showDialog(rowIndex){
            this.tableData = [];
            this.visible = true;
            this.rowIndex = rowIndex;
            this.selectPlatform();
        },
        openPddLogin(){
            window.open("https://mobile.yangkeduo.com/login.html");
        },
        selectPlatform(){
            //目前只有拼多多支持
            //检测是否是最新版本插件
            /* global chrome */
            const extId = document.body.getAttribute('ba-ext-id');
            if(extId && window.chrome && chrome.runtime){
                let responded = false;
                const timeoutId = setTimeout(() => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    this.$message("请先更新插件到最新版本");
                }, 1000);
                chrome.runtime.sendMessage(extId, {
                    action: 'getVersion',
                }, response => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    clearTimeout(timeoutId);
                    if (chrome.runtime.lastError) {
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                    if (response && response.data) {
                        const version = response.data;
                        if(this.$kit.compareVersion(version, this.dicts.chromeVersion) < 0){
                            this.$message("插件版本过低，请移除后下载安装最新版本");
                            return;
                        }else{
                            //执行获取拼多多单号操作
                            this.getPddCodes();
                        }
                    }else{
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                });
            }else{
                this.$message("插件版本过低，请移除后下载安装最新版本");
                return;
            }
        },
        getPddCodes(){
            //执行获取拼多多单号操作
            let extId = document.body.getAttribute('ba-ext-id');
            /* global chrome */
            if (extId && chrome && chrome.runtime) {
                const requestId = 'req_' + Date.now() + '_' + Math.random().toString(36).slice(2);
                chrome.runtime.sendMessage(extId, {
                    action: 'AllOrders',
                    requestId
                }, response => {
                    if (!response) return;
                    if (response.requestId !== undefined && response.requestId !== requestId) return;
                    console.log('获取拼多多采购单号结果:', response);
                    if (response.success && response.data) {
                        let data = response.data;
                        data.forEach(order => {
                            let detail = order.details[0];
                            let item = {
                                orderCode: order.orderId,
                                spec: detail.spec,
                                qty: detail.qty,
                                price: detail.price,
                                status: order.status,
                                created: order.createdAt
                            };
                            this.tableData.push(item);
                        });
                    }else{
                        this.$message(response.error || "获取单号失败，请先登录拼多多");
                    }
                });
            } else {
                this.$message('插件未安装或未启用');
            }
        },
        submitCode(order){
            this.visible = false;
            this.$emit('finish', order,this.rowIndex);
        }
    }
}

</script>
